"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _checkbox = _interopRequireDefault(require("./checkbox.css"));
var Checkbox = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function Checkbox() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(Checkbox, _React$PureComponent);
  var _proto = Checkbox.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      id = _this$props.id,
      testID = _this$props['data-testid'],
      checked = _this$props.checked,
      children = _this$props.children,
      className = _this$props.className,
      name = _this$props.name,
      onChange = _this$props.onChange,
      value = _this$props.value;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_checkbox["default"].checkbox, className)
    }, /*#__PURE__*/_react["default"].createElement("input", {
      "data-testid": testID,
      id: id,
      type: "checkbox",
      className: _checkbox["default"].input,
      name: name,
      onChange: onChange,
      value: value,
      checked: checked
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: id,
      className: _checkbox["default"].label
    }, children));
  };
  return Checkbox;
}(_react["default"].PureComponent);